import React, { Component } from 'react'
import Footer from '../../Component/Footer'
import Header from '../../Component/Header'
import Menu from '../../Component/Menu'
import ViewQuotation from './ViewQuotation'

export default class ViewQuotationWrapper extends Component {
    render() {
        return (
            <div>
                <Header />
                 <Menu/>
                <>
              <div className="content-wrapper">
              <ViewQuotation/>
              </div>
              </>
              <Footer/>
            </div>
        )
    }
}